import { type CounterEffect, type SetSwitchProps, type SetCounterProps, type SetVariableProps, type SetNewGameProps } from 'src/types'

// === PRIMITIVES === //
const setSwitch = (dispatch: (arg0: SetSwitchProps) => void, switchID: string, boolean: boolean) => {
  dispatch({
    type: 'SET_SWITCH',
    switchID,
    boolean
  })
}

const setCounter = (dispatch: (arg0: SetCounterProps) => void, counterID: string, counterEffect: CounterEffect) => {
  dispatch({
    type: 'SET_COUNTER',
    counterID,
    counterEffect
  })
}

const setVariable = (dispatch: (arg0: SetVariableProps) => void, variableID: string, string: string) => {
  dispatch({
    type: 'SET_VARIABLE',
    variableID,
    string
  })
}

const newGame = (dispatch: (arg0: SetNewGameProps) => void) => {
  dispatch({
    type: 'NEW_GAME'
  })
}

const restartGame = (dispatch: (arg0: SetNewGameProps) => void) => {
  dispatch({
    type: 'RESTART_GAME'
  })
}

export {
  setSwitch,
  setCounter,
  setVariable,
  newGame,
  restartGame
}
